import { render } from "./OfflineModal.vue?vue&type=template&id=06d7c5ae&scoped=true"
import script from "./OfflineModal.vue?vue&type=script&lang=ts"
export * from "./OfflineModal.vue?vue&type=script&lang=ts"

import "./OfflineModal.vue?vue&type=style&index=0&id=06d7c5ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06d7c5ae"

export default script